import {MyopBindMessage, MyopBindReplayMessage, Ref} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";
import {Serializable} from "../common/utils/serialization.ts";

const ReplayMessageKey = 'ElementValueReplayMessage'

export class GetElementValueMessage extends MyopBindMessage<void, ElementValueReplayMessage> {
    replyMessageKey: MyopMessageKey = ReplayMessageKey
    messageType = 'GetElementValueMessage';

    constructor(public ref: Ref, handler: (message: ElementValueReplayMessage) => void) {
        super(handler);
    }
}

export type FormDataEntry = {
    id?: string,
    name?: string,
    value?: InputElementValue,
    required?: boolean,
    validity?: Serializable<ValidityState>,
    myopId?: string
}

export type InputElementFormValue = {
    formData?: { [key: string]: FormDataEntry }
    unmappedData?: FormDataEntry[]
};

export type InputElementValue = string | InputElementFormValue | null | undefined

export class ElementValueReplayMessage extends MyopBindReplayMessage {
    messageType = ReplayMessageKey

    constructor(public content: InputElementValue) {
        super();
    }
}

